import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Status from 'client/components/aria/Status/Status';
import styles from './DataRefreshStatus.module.scss';

/**
 * DataRefreshStatus component
 * Displays the data refresh status (in-date or out-of-date) using the Status component
 */
const DataRefreshStatus = ({ isOutOfDate, daysOverdue, className, ...props }) => {
    const intl = useIntl();

    const containerClassName = [styles.container, className].filter(Boolean).join(' ');

    if (isOutOfDate) {
        const messageId = daysOverdue === 0
            ? 'selectFeaturePanel.dataRefresh.lessThanOneDayOverdue'
            : 'selectFeaturePanel.dataRefresh.outOfDate';

        return (
            <div className={containerClassName} {...props}>
                <Status variant="red" data-testid="statusTagOutOfDate">
                    {intl.formatMessage({ id: messageId }, { days: daysOverdue })}
                </Status>
            </div>
        );
    }

    return (
        <div className={containerClassName} {...props}>
            <Status variant="green" data-testid="statusTagInDate">
                {intl.formatMessage({ id: 'selectFeaturePanel.dataRefresh.inDate' })}
            </Status>
        </div>
    );
};

DataRefreshStatus.propTypes = {
    isOutOfDate: PropTypes.bool.isRequired,
    daysOverdue: PropTypes.number,
    className: PropTypes.string
};

DataRefreshStatus.defaultProps = {
    daysOverdue: 0,
    className: ''
};

export default DataRefreshStatus;
